import { useEffect, useState } from "react";
import axios from "axios";
import { logDev } from "../utils/logger.js";

import { useLanguage } from '../context/LanguageContext.js';

export default function QuotaInfo({ groupeId, isAdmin, reloadTrigger }) {
  const [info, setInfo] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const { t } = useLanguage();   
 
  useEffect(() => {
    if (!isAdmin || !groupeId) return;

    axios
      .get(`${process.env.REACT_APP_API}/paiement/context/${groupeId}`)
      .then(res => {
        logDev("📦 QuotaInfo reçu", res.data);
        setInfo(res.data);
      })
      .catch(err => {
        logDev("❌ Erreur chargement QuotaInfo", { message: err.message });
      });
  }, [groupeId, isAdmin,reloadTrigger]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!info) return null;

  const { quota, groupe } = info;
  const joursQuota = typeof quota.joursRestants === "number" ? quota.joursRestants : null;
  
  const dateFinQuota = info.abonnement?.dateFin
    ? new Date(info.abonnement.dateFin).toLocaleDateString("fr-FR")
    : "à venir";

  const couleur = groupe.couleur || "#71685e";
  const couleurUrgence = joursQuota !== null && joursQuota < 7 ? "#d32f2f" : couleur;


  // Quota groupes (déjà existant)
  /*const quotaGroupes = groupe.positionDansQuota
    ? `${groupe.positionDansQuota}/${quota.groupesMax}`
    : `${quota.groupesUtilises}/${quota.groupesMax}`;*/
  //const quotaGroupes = `${quota.groupesUtilises}/${quota.groupesMax}`;  
  const quotaGroupes = `${info.flags?.positionDansQuota || 1}/${quota.groupesUtilises}`;

  // ➕ Nouveau : quota contacts
  const quotaContacts = quota.contactsUtilises !== undefined
    ? `${quota.contactsUtilises}/${quota.contactsMax}`
    : "0/0";
  
  const emoji = groupe.emoji || "";

  return (
    <div
      style={{
        position: "relative",
        top: 0,
        marginTop: isMobile ? "2px" : "4px",
        marginBottom: isMobile ? "6px" : "10px",
        marginLeft: "auto",
        marginRight: isMobile ? "4px" : "12px",
        background: "none",
        border: `1px solid ${couleur}`,
        borderRadius: 4,
        padding: isMobile ? "2px 5px" : "3px 7px",
        fontSize: isMobile ? "0.6rem" : "0.68rem",
        color: couleurUrgence,
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        maxWidth: isMobile ? "80px" : "110px",
        zIndex: 5,
        backdropFilter: "blur(2px)"
      }}
    >
      <div style={{ fontSize: isMobile ? "0.9rem" : "1rem", marginBottom: 2 }}>{emoji}</div>
      <div><strong>{t("GroupNumber")},</strong> {quotaGroupes}</div>
      <div><strong>{t("Contacts")},</strong> {quotaContacts}</div>
      <div><strong>{t("Duration")}</strong> {joursQuota !== null ? `${joursQuota} ${t("DayShort")}` : dateFinQuota}</div>

      <button
        onClick={() => {
          const url = `/paiement/${groupeId}`;

          logDev("🔗 Redirection vers paiement", {
          url,
          groupeId
        });

        window.location.href = url;
        }}

        style={{
          marginTop: 4,
          background: "none",
          border: "none",
          padding: 0,
          color: couleur,
          textDecoration: "underline",
          fontSize: isMobile ? "0.65rem" : "0.75rem",
          cursor: "pointer"
        }}
      >
        {t("Subscription")}
      </button>
    </div>
  );
}
